module.exports = __webpack_public_path__ + "public/img/kesekretariatan dan komunikasi untuk menjadi sekretaris-2.6ec0b145.png";